<template>
  <span class="subtitle-2">
    {{ text }}
  </span>
</template>

<script>
export default {
  name: 'AnchorRecordCounter',
  props: {
    append: String,
    counter: {
      type: Number,
      default: 0,
    },
    singular: {
      type: String,
      default: 'record',
    },
    plural: {
      type: String,
      default: 'records',
    },
  },
  computed: {
    text: vm => `Found ${vm.counter} ${vm.counter === 1 ? vm.singular : vm.plural} ${vm.append || ''}`.trim(),
  },
};
</script>
